module.exports = __webpack_public_path__ + "static/media/logowhite.8a4b7142.svg";